export const environment = {
  production: false,
  environmentName: 'dev',

  domainName: 'cordelllaw',
  tenantId: 'a3a79d12-cac2-4d4d-82a4-22eeb4946eda',
  appClientId: 'ac4f5200-fc49-4e56-bd43-139d9dc5aa38',
  appIdUri: 'api://lexicon-surveys-dev02',

  apiEndpointUrl: 'https://surveysapidev.lexiconservices.com',

  useLogRocket: false,

  // Search debounce time in milliseconds
  searchDebounceTime: 2000
};
